/* eslint-disable no-unreachable */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import api from "../../utils/api";
import { InlineMath, BlockMath } from "react-katex";
import "katex/dist/katex.min.css";
import "../../Pages/questions/QuestionDetails.css";
import he from "he"; // Import the 'he' library to decode HTML entities
import "../../Pages/questions/importQuestion.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const PreviousPaper = () => {
  const [activePaperId, setActivePaperId] = useState(null);
  const navigate = useNavigate();
  const [fetchedData, setFetchedData] = useState([]);
  const [visibleQuestions, setVisibleQuestions] = useState(50); // Number of questions visible
  const [loading, setLoading] = useState(false); // To track data fetching
  const [allPickedQuestions, setAllPickedQuestions] = useState([]); // Global state to track picked questions
  const [subjectLimits, setSubjectLimits] = useState({});
  const [currentSection, setCurrentSection] = useState(1); // Track the current section
  const [notFound, setNotFound] = useState(false);
  const [papers, setPapers] = useState([]); // Ensure papers is never undefined
  const [filteredData, setFilteredData] = useState(fetchedData); // New state for filtered questions
  const { id: paperId } = useParams(); // Get paperId from URL
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredData(fetchedData); // Reset if search is empty
    } else {
      const filtered = fetchedData.filter((q) =>
        q.question.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, [searchTerm, fetchedData]);

  useEffect(() => {
    fetchTemplateDetails();
    initializePickedQuestions();
  }, []);

  // Fetch data with all filters applied
  async function fetchData(
    id,
    page = 1,
    limit = 50,
    search = null // This will be the `questionId` for search
  ) {
    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = "getPaperDetailsFromPaperId";

    try {
      setLoading(true); // Start loading
      setNotFound(false); // Reset "not found" state

      const postData = async (url, data) => {
        const fd = new FormData();
        fd.append("paperId", id); // Ensure correct paperId
        // console.log("Paper ID:", id); // ✅ Debugging check

        Object.entries(data).forEach(([key, value]) => {
          if (value !== null && value !== undefined && value !== "") {
            fd.append(key, value);
          }
        });

        const response = await api.post(url, fd);
        return response.data || {};
      };

      const filterData = {
        programType,
        loggedInUser,
        token,
        page,
        limit,
        paperId: id,
        search: search || "", // Include search filter
      };

      // console.log("Fetching with Filters:", filterData);

      // Fetch questions
      const questionData = await postData("question/paperImport", filterData);
      // console.log("API Response:", questionData);

      const questions = Array.isArray(questionData.questions)
        ? questionData.questions
        : [];

      // Fetch selected question IDs
      const selectedData = await postData("picQuestion/picQuestionCurl", {
        programType: "getSelectedQUestionInPaper",
        loggedInUser,
        token,
        paperId: paperId,
      });

      const selectedQuestionIds = Array.isArray(selectedData)
        ? selectedData.map((q) => q.questionId)
        : [];

      // console.log("Selected Question IDs:", selectedQuestionIds);

      // Map questions and mark selected ones
      const updatedQuestions = questions.map((q) => ({
        ...q,
        isPicked: selectedQuestionIds.includes(q.id),
      }));

      setFetchedData(updatedQuestions);
      setFilteredData(updatedQuestions); // Ensure search data updates

      // If no questions found, update state
      setNotFound(updatedQuestions.length === 0);
    } catch (error) {
      console.error("Error fetching questions:", error);
    } finally {
      setLoading(false); // End loading state
    }
  }

  useEffect(() => {
    fetchPapers(); // Fetch papers on component mount
  }, []);

  async function fetchPapers() {
    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = "getPaperDetailsForPreviousPaperDetails"; // Update this based on API

    const fd = new FormData();
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("paperId", paperId);

    try {
      const response = await api.post("question/paperImport", fd);
      console.log("papers", response);

      if (response.data?.status === "success") {
        setPapers(response.data?.getPaperDetails || []);
      }
    } catch (error) {
      console.error("Error fetching papers:", error);
    }
  }

  async function fetchTemplateDetails() {
    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = "getTemplateDetailsInAddQuestions";

    const fd = new FormData();
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("id", paperId);

    try {
      const response = await api.post("paper/paperCurl", fd);
      const templateDetails = JSON.parse(response.data.data[0].details);

      // console.log("Template Details:", templateDetails);

      const subjectLimits = {};

      // Extract subject limits from sections
      Object.values(templateDetails.sections).forEach((section) => {
        const sectionNumber = section.sectionNumber;
        const totalSectionQuestions = parseInt(section.totalQuestions, 10);

        Object.values(section.subjects).forEach((subject) => {
          if (!subjectLimits[sectionNumber]) {
            subjectLimits[sectionNumber] = {
              totalQuestions: totalSectionQuestions,
              pickedQuestions: 0,
              subjects: {},
            };
          }
          subjectLimits[sectionNumber].subjects[subject.subjectId] = {
            subjectName: subject.subjectName,
            noOfQuestions: parseInt(subject.noOfQuestions, 10),
            pickedQuestions: 0, // Initialize to 0, will update later
          };
        });
      });

      // Fetch previously picked questions
      const pickedQuestions = await initializePickedQuestions();
      // console.log("Picked Questions on Page Load:", pickedQuestions);

      // Update picked questions count in subjectLimits
      pickedQuestions.forEach(({ subjectId }) => {
        Object.keys(subjectLimits).forEach((sectionId) => {
          if (subjectLimits[sectionId].subjects[subjectId]) {
            subjectLimits[sectionId].subjects[subjectId].pickedQuestions++;
            subjectLimits[sectionId].pickedQuestions++;
          }
        });
      });

      setSubjectLimits(subjectLimits);
    } catch (error) {
      // console.error("Error fetching template details:", error);
    }
  }

  // Initialize globally picked questions
  const initializePickedQuestions = async () => {
    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");

    try {
      const fd = new FormData();
      fd.append("programType", "getSelectedQUestionInPaper");
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("paperId", paperId);

      const response = await api.post("picQuestion/picQuestionCurl", fd);

      const selectedQuestions = Array.isArray(response.data)
        ? response.data.map((q) => ({
            id: q.questionId,
            subjectId: q.subjectId,
          }))
        : [];

      setAllPickedQuestions(selectedQuestions);

      return selectedQuestions; // Return picked questions so we can update subjectLimits
    } catch (error) {
      // console.error("Error initializing picked questions:", error);
      return [];
    }
  };

  // Handle question pick/unpick
  const togglePickQuestion = async (questionId) => {
    const questionIndex = fetchedData.findIndex((q) => q.id === questionId);
    if (questionIndex === -1) {
      toast.error("Question not found in fetchedData");
      return;
    }

    const question = fetchedData[questionIndex];
    // console.log("Question Object:", question); // Add this log for debugging

    const isCurrentlyPicked = question.isPicked;

    if (question.subjectId === undefined) {
      toast.error("Subject ID is undefined for Question ID:", questionId);
      return;
    }
    // Initialize variables for section handling
    let sectionIds = Object.keys(subjectLimits);
    let currentSectionIndex = parseInt(currentSection, 10) - 1; // Start from the current section index (0-based)
    const totalSections = sectionIds.length;
    let foundSection = false;

    while (currentSectionIndex < totalSections) {
      const currentSection = sectionIds[currentSectionIndex];
      const section = subjectLimits[currentSection];

      if (!section) {
        toast.error(`Section ${currentSection} not found in subjectLimits.`);
        return;
      }

      const subject = section.subjects?.[question.subjectId];
      if (!subject) {
        toast.error(
          `Subject ID ${question.subjectId} not found in section ${currentSection}.`
        );
        return;
      }

      // Prevent picking more questions than the limit for this section and subject
      if (!isCurrentlyPicked) {
        if (
          section.pickedQuestions >= section.totalQuestions ||
          subject.pickedQuestions >= subject.noOfQuestions
        ) {
          toast.error(
            `You cannot pick more questions from Section ${currentSection}`
          );
          return;
        }
      }

      foundSection = true;
      break;

      // Move to the next section if no valid section is found
      currentSectionIndex++;
    }

    if (!foundSection) {
      toast.error("No suitable section available for this question.");
      return;
    }

    const selectedSection = sectionIds[currentSectionIndex];
    const selectedSubject =
      subjectLimits[selectedSection].subjects[question.subjectId];

    // Optimistic state update
    const updatedQuestions = [...fetchedData];
    updatedQuestions[questionIndex].isPicked = !isCurrentlyPicked;
    setFetchedData(updatedQuestions);

    const updatedLimits = { ...subjectLimits };
    if (isCurrentlyPicked) {
      updatedLimits[selectedSection].pickedQuestions--;
      selectedSubject.pickedQuestions--;
    } else {
      updatedLimits[selectedSection].pickedQuestions++;
      selectedSubject.pickedQuestions++;
    }
    setSubjectLimits(updatedLimits);

    // API request to sync changes
    try {
      const programType = isCurrentlyPicked ? "removeQuestion" : "addQuestion";
      const fd = new FormData();
      fd.append("programType", programType);
      fd.append("loggedInUser", localStorage.getItem("loggedInUser"));
      fd.append("token", localStorage.getItem("authToken"));
      fd.append("paperId", paperId);
      fd.append("questionId", questionId);

      const response = await api.post("picQuestion/picQuestionCurl", fd);
      // console.log("Response data:", response.data);

      if (response.data && response.data.status === true) {
        // console.log(response.data.data);
      } else {
        throw new Error(response.data.message || "Failed to update question");
      }
    } catch (error) {
      // console.error("Error toggling question pick:", error);

      // Revert optimistic updates in case of an error
      const revertedQuestions = [...fetchedData];
      revertedQuestions[questionIndex].isPicked = isCurrentlyPicked;
      setFetchedData(revertedQuestions);

      const revertedLimits = { ...subjectLimits };
      if (isCurrentlyPicked) {
        revertedLimits[selectedSection].pickedQuestions++;
        selectedSubject.pickedQuestions++;
      } else {
        revertedLimits[selectedSection].pickedQuestions--;
        selectedSubject.pickedQuestions--;
      }
      setSubjectLimits(revertedLimits);
    }

    // Log the sections and the questions picked in each section
    // console.log("Questions Distribution Across Sections:");
    Object.keys(subjectLimits).forEach((sectionId) => {
      const section = subjectLimits[sectionId];
      // console.log(`Section ${sectionId}:`);

      Object.values(section.subjects).forEach((subject) => {
        const pickedQuestionsInSubject = subject.pickedQuestions;
        if (pickedQuestionsInSubject > 0) {
          // console.log(
          //   `  Subject: ${subject.subjectName}, Picked Questions: ${pickedQuestionsInSubject}`
          // );
        }
      });
    });
  };

  const renderLatexText = (text) => {
    if (!text) return null; // Check for undefined, null, or empty string

    const decodedText = he.decode(text); // Decode HTML entities
    const latexAndImageRegex =
      /\\\((.*?)\\\)|\\\[(.*?)\\\]|<img[^>]*\bsrc=(["'])(.*?)\3[^>]*>|\\begin{align}([\s\S]*?)\\end{align}/g;

    const parts = [];
    let lastIndex = 0;

    decodedText.replace(
      latexAndImageRegex,
      (
        match,
        inlineLatex,
        blockLatex,
        quote,
        imageSrc,
        alignContent,
        index
      ) => {
        if (index > lastIndex) {
          parts.push(decodedText.slice(lastIndex, index));
        }

        if (imageSrc) {
          parts.push(
            <img
              key={index}
              src={imageSrc}
              alt="Image"
              style={{
                maxWidth: "100%",
                display: "inline",
                verticalAlign: "middle",
                marginLeft: "4px",
                marginRight: "4px",
              }}
            />
          );
        } else if (alignContent) {
          parts.push(
            <BlockMath
              key={index}
              style={{
                display: "block",
                textAlign: "center",
                margin: "10px 0",
                whiteSpace: "pre-line", // Preserves line breaks
              }}
            >
              {`\\begin{align}${alignContent}\\end{align}`}
            </BlockMath>
          );
        } else if (inlineLatex || blockLatex) {
          parts.push(
            <InlineMath
              key={index}
              style={{
                display: "inline",
                verticalAlign: "middle",
                marginLeft: "4px",
                marginRight: "4px",
              }}
            >
              {inlineLatex || blockLatex}
            </InlineMath>
          );
        }

        lastIndex = index + match.length;
      }
    );

    if (lastIndex < decodedText.length) {
      parts.push(decodedText.slice(lastIndex));
    }

    return (
      <span style={{ whiteSpace: "normal", display: "inline" }}>{parts}</span>
    );
  };

  const toggleShowAnswer = (index) => {
    setFetchedData((prevData) =>
      prevData.map((question, idx) =>
        idx === index
          ? { ...question, showAnswer: !question.showAnswer }
          : question
      )
    );
  };

  useEffect(() => {
    fetchTemplateDetails();
  }, []); // Fetch data when the component mounts

  return (
    <div className="dashboard-body">
      {/* Breadcrumb */}
      <div className="breadcrumb-with-buttons flex-between flex-wrap gap-8">
        <div className="breadcrumb ">
          <ul className="flex-align gap-4">
            <li>
              <Link
                to="/paper-details"
                className="text-gray-200 fw-normal text-15 hover-text-main-600"
              >
                Question Paper
              </Link>
            </li>
            <li>
              <span className="text-gray-500 fw-normal d-flex">
                <i className="ph ph-caret-right"></i>
              </span>
            </li>
            <li>
              <span className="text-main-600 fw-normal text-15">
                Pick Questions
              </span>
            </li>
          </ul>
        </div>

        <ToastContainer />

        <div className=" flex-align gap-8 flex-wrap">
          <div
            className="flex-align gap-8 flex-wrap"
            style={{
              backgroundColor: "white",
              border: "2px black",
              borderRadius: "10px",
            }}
          >
            <input
              type="text"
              name="search"
              className="form-control"
              style={{ backgroundColor: "white" }}
              placeholder="Search by Question"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)} // Update searchTerm
            />
          </div>
          
        </div>
      </div>

      <div className="row">
        <div className="col-12 col-md-12 col-lg-4">
          <div className="fixed-sidebar">
            {/* Papers List */}
            <div className="card" style={{ backgroundColor: "#ECF2FE" }}>
              <div className="card-header">
                {papers.length > 0 ? (
                  <div className="row g-3">
                    {papers.map((paper) => (
                      <div key={paper.id} className="col-12">
                        <div
                          className="card w-100 p-3 shadow-sm border-0"
                          onClick={() => {
                            setActivePaperId(paper.id); // Set active paper
                            fetchData(paper.id);
                          }}
                          style={{
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            backgroundColor:
                              activePaperId === paper.id
                                ? "#E0E0E0"
                                : "#FFFFFF", // Gray when active
                            boxShadow:
                              activePaperId === paper.id
                                ? "0 4px 10px rgba(0,0,0,0.2)"
                                : "none",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.boxShadow =
                              activePaperId === paper.id
                                ? "0 4px 10px rgba(0,0,0,0.3)"
                                : "0 4px 10px rgba(0,0,0,0.1)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.boxShadow =
                              activePaperId === paper.id
                                ? "0 4px 10px rgba(0,0,0,0.2)"
                                : "none")
                          }
                        >
                          <div className="card-body text-center">
                            <h6 className="fw-bold mb-2">{paper.paperName}</h6>
                            <p className="text-muted mb-0">
                              Total Questions: {paper.noOfQuestions}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-center text-muted">No papers available</p>
                )}
              </div>
            </div>

            {/* Subject Limits */}
            <div className="card" style={{ backgroundColor: "#ECF2FE" }}>
              <div className="card-header">
                <div
                  className="card mb-3  mt-20"
                  style={{ backgroundColor: "#F8D7D9" }}
                >
                  <div className="card-body" style={{ color: "#667697" }}>
                    {Object.keys(subjectLimits).map((sectionId) => {
                      const section = subjectLimits[sectionId];
                      return (
                        <div key={sectionId} className="section-info mt-2">
                          <h6 className="fw-bold">Section {sectionId}</h6>
                          {Object.values(section.subjects).map((subject) => {
                            const selectedQuestionsCount =
                              subject.pickedQuestions;
                            const totalQuestions = subject.noOfQuestions;

                            return (
                              <div
                                key={subject.subjectId}
                                className="subject-info"
                              >
                                <p className="mb-1">
                                  <strong>{subject.subjectName}</strong>:{" "}
                                  {selectedQuestionsCount} / {totalQuestions}{" "}
                                  Selected
                                </p>
                              </div>
                            );
                          })}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-12 col-lg-8">
          <div className=" ">
            <div className="card-header">
              <ul>
                {/* Questions List - Using Filtered Data */}
                {filteredData.length > 0 ? (
                  filteredData
                    .slice(0, visibleQuestions)
                    .map((question, index) => (
                      <div
                        key={index}
                        className={`card mt-24 ${
                          question.isPicked ? "bg-light-primary" : ""
                        }`}
                        style={{
                          border: question.isPicked
                            ? "2px solid #007bff"
                            : "1px solid #ddd",
                          transition: "background-color 0.3s, border 0.3s",
                          backgroundColor: question.isPicked
                            ? "whitesmoke"
                            : "white",
                        }}
                      >
                        <div
                          className="card-header"
                          style={{ position: "relative" }}
                        >
                          <div style={{ display: "flex" }}>
                            <div
                              className="text-13 py-2 px-8 bg-success-50 text-success-600 d-inline-flex align-items-center gap-8 rounded-pill"
                              style={{
                                marginRight: "10px",
                                marginBottom: "8px",
                              }}
                            >
                              {question.levelName}
                            </div>
                            <div
                              className="text-13 py-2 px-8 bg-danger-50 text-danger-600 d-inline-flex align-items-center gap-8 rounded-pill"
                              style={{
                                marginRight: "10px",
                                marginBottom: "8px",
                              }}
                            >
                              {question.examType}
                            </div>
                            <div
                              className="text-13 py-2 px-8 bg-warning-50 text-warning-600 d-inline-flex align-items-center gap-8 rounded-pill"
                              style={{
                                marginRight: "10px",
                                marginBottom: "8px",
                              }}
                            >
                              Question Id: {question.id}
                            </div>
                          </div>
                          <p style={{ marginTop: "20px", fontSize: "15px" }}>
                            {index + 1}.{renderLatexText(question.question)}
                          </p>

                          {/* Pick/Remove Question Button */}
                          <button
                            className={`btn ${
                              question.isPicked ? "btn-danger" : "btn-primary"
                            }`}
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "10px",
                              fontSize: "12px",
                            }}
                            onClick={() => togglePickQuestion(question.id)}
                          >
                            {question.isPicked ? "Remove" : "Pick"}
                          </button>

                          {/* Options List */}
                          {question.options && question.options.length > 0 && (
                            <p style={{ fontWeight: "600", marginTop: "20px" }}>
                              Options:
                            </p>
                          )}

                          <div
                            className={`options-list ${
                              question.options?.some((opt) => opt.length > 50)
                                ? "one-column"
                                : "two-columns"
                            }`}
                            style={{
                              margin: "0",
                              padding: "0",
                              display: "grid",
                              gridTemplateColumns: question.options?.some(
                                (opt) => opt.length > 50
                              )
                                ? "1fr"
                                : "1fr 1fr",
                              gap: "15px",
                            }}
                          >
                            {question.options.map((option, idx) => (
                              <div
                                key={idx}
                                style={{
                                  padding: "8px 12px",
                                  wordBreak: "break-word",
                                }}
                              >
                                <strong>{idx + 1}.</strong>{" "}
                                {renderLatexText(option)}
                              </div>
                            ))}
                          </div>

                          <hr style={{ borderTop: "1px dashed black" }} />
                          <div style={{ display: "flex" }}>
                            <button
                              onClick={() => toggleShowAnswer(index)}
                              className="btn btn-main rounded-pill p-10"
                              style={{ marginLeft: "auto", fontSize: "12px" }}
                            >
                              {question.showAnswer
                                ? "Hide Answer"
                                : "Show Answer"}
                            </button>
                          </div>
                          {question.showAnswer && (
                            <div>
                              <p>
                                <strong>Explanation:</strong>{" "}
                                {renderLatexText(question.explanation)}
                              </p>
                              <p className="mt-10">
                                <strong>Answer:</strong>{" "}
                                {renderLatexText(question.answer)}
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    ))
                ) : (
                  <p
                    className="text-center text-muted"
                    style={{ margin: "200px" }}
                  >
                    Please Select a Paper
                  </p>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviousPaper;
